import api from './client';

// ============ Stripe Connect Express (Phase 7) ============
// Stripe Connect Express handles onboarding, KYC (identity verification),
// payout details and tax info in a single flow.
// Phase 36.2 — creator must select country of residence before onboarding.

export const stripeConnectOnboard = async (country) => {
  const res = await api.post('/payouts/onboard', {
    country,
    origin: window.location.origin,
  });
  return res.data;
};

export const stripeConnectMockComplete = async () => {
  const res = await api.post('/payouts/onboard/mock-complete');
  return res.data;
};

export const stripeConnectRefresh = async () => {
  const res = await api.post('/payouts/onboard/refresh');
  return res.data;
};

export const stripeConnectListCountries = async () => {
  const res = await api.get('/payouts/countries');
  return res.data.countries || [];
};

export const stripeConnectResetOnboarding = async () => {
  const res = await api.post('/payouts/onboard/reset');
  return res.data;
};
